import React, { useState } from 'react';
import { Timer } from 'lucide-react';
import { messageErreur, reservationsApi, type Reservation } from '../../lib/reservationsApi';

/** Minutes entre deux dates locales « 2026-10-15T20:00 » (vide si l'une manque). */
const minutesEntre = (de: string, a: string) => Math.ceil((Date.parse(`${a}:00Z`) - Date.parse(`${de}:00Z`)) / 60000);

/**
 * Liste d'attente : proposer sa place à la demande. Tant que l'offre court, les couverts sont gardés (personne d'autre ne les prend) et le livre
 * affiche le compte à rebours ; sans SMS ni e-mail pour l'instant, c'est l'équipe qui prévient le client. Confirmer la réservation efface l'offre.
 */
export const OffrePlace: React.FC<{ r: Reservation; maintenant: string; onMaj: () => void }> = ({ r, maintenant, onMaj }) => {
    const [enCours, setEnCours] = useState(false);
    const [erreur, setErreur] = useState('');
    if (r.statut !== 'attente') return null;
    const agir = async (f: () => Promise<unknown>) => { setEnCours(true); setErreur(''); try { await f(); onMaj(); } catch (e) { setErreur(messageErreur(e)); } finally { setEnCours(false); } };
    const reste = r.offre_jusqu_a ? minutesEntre(maintenant, r.offre_jusqu_a) : null;
    const bouton = 'inline-flex items-center min-h-[32px] max-lg:min-h-[44px] px-2.5 rounded-full border border-border bg-surface text-[12px] font-semibold text-content hover:bg-surface-soft disabled:opacity-50';
    return (
        <div className="mt-1 space-y-1" onClick={(e) => e.stopPropagation()}>
            {reste !== null ? (
                <div className="flex flex-wrap items-center gap-2">
                    <span className="inline-flex items-center gap-1 text-[12px] font-semibold text-state-warn"><Timer size={13} aria-hidden="true" />Place gardée · expire dans {Math.max(reste, 1)} min</span>
                    <button type="button" disabled={enCours} className={bouton} onClick={() => void agir(() => reservationsApi.retirerOffre(r.id))}>Retirer l’offre</button>
                </div>
            ) : (
                <div className="flex flex-wrap items-center gap-2">
                    {r.offre_expiree && <span className="text-[12px] font-semibold text-content-muted">Offre expirée</span>}
                    <button type="button" disabled={enCours} className={bouton} onClick={() => void agir(() => reservationsApi.proposerPlace(r.id))}>{r.offre_expiree ? 'Proposer à nouveau' : 'Proposer la place'}</button>
                </div>
            )}
            {erreur && <p role="alert" className="text-[12px] font-semibold text-state-danger">{erreur}</p>}
        </div>
    );
};
